/* eslint-disable @typescript-eslint/no-misused-promises */

import React, { useState } from 'react';
import { useMemoizedFn } from 'ahooks';
import ReportPage from '../../../components/ReportPage';
import ReportForm from '../ReportForm';
import useEditDPSReport from '../../_hooks/useEditDPSReport';
import { getStorageReport } from '../../../utils';
import { CONSTANT_TEXTS } from '@gp/constants/const';

import type { IDPSReportFormValue } from '../../types';

import '../../../scss/index.scss';

const DEFAULT_FORM_VALUE: IDPSReportFormValue = {
  comment: '',
  hightlights: [],
  changes: [],
  miscellaneous: [],
  calendar: [],
};

const EditReportV2: React.FC = () => {
  const {
    isGuide,
    isLoading,
    isHightlightsInnerLoading,
    isCalendarInnerLoading,
    isSubmitting,
    submitType,
    reportHelper,
    projectsMilestones,
    onHightlightsRefreshData,
    onCalendarRefreshData,
    onSubmit,
  } = useEditDPSReport({
    getReport: () => ({ ...reportFormValue }),
    setReport: (payload) => {
      setReportFormValue({ ...reportFormValue, ...payload });
    },
  });

  const [reportFormValue, setReportFormValue] = useState<IDPSReportFormValue>(DEFAULT_FORM_VALUE);

  const handleConfirm = useMemoizedFn(async (isPublish: boolean) => {
    const storageReport = getStorageReport() || {};
    onSubmit({ ...reportFormValue }, isPublish, {
      reportId: storageReport?.report_id || '',
      tips: `${CONSTANT_TEXTS.OPERATION_SUCCESS_TIPS}! Unpublished by default`,
    });
  });

  return (
    <ReportPage
      className="dbg-edit-dps-report-page"
      title="Edit"
      isEdit={true}
      isGuide={isGuide}
      isLoading={isLoading}
      isHightlightsInnerLoading={isHightlightsInnerLoading}
      isCalendarInnerLoading={isCalendarInnerLoading}
      isSubmitting={isSubmitting}
      submitType={submitType}
      reportHelper={reportHelper}
      projectsMilestones={projectsMilestones}
      onHightlightsRefreshData={onHightlightsRefreshData}
      onCalendarRefreshData={onCalendarRefreshData}
      onConfirm={handleConfirm}
      form={
        <ReportForm
          isLoading={isLoading}
          isHightlightsInnerLoading={isHightlightsInnerLoading}
          isCalendarInnerLoading={isCalendarInnerLoading}
          reportHelper={reportHelper}
          projectsMilestones={projectsMilestones}
          value={reportFormValue}
          onChange={setReportFormValue}
          onHightlightsRefreshData={onHightlightsRefreshData}
          onCalendarRefreshData={onCalendarRefreshData}
        />
      }
    />
  );
};

export default EditReportV2;
